module.exports = __webpack_public_path__ + "media/images/hero-BG-dcb4c9b7.jpg";